import React from 'react'

interface TableHeadProps {
  children: React.ReactNode
}

export default function TableHead({ children }: TableHeadProps): JSX.Element {
  return <thead className="tw-h-4 tw-bg-gray-50">{children}</thead>
}
